import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import {
  userGetCurrent, userLogout,
} from '@uncinc/react-drupal-core';

import CartSummary from '../CartSummary';

import './style.scss';
import { usePrevious } from '../../helpers/usePrevious';

const WebshopLinks = ({ setShowCartPopup }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { t } = useTranslation();
  const urlParams = new URLSearchParams(window.location.search);
  const loggedIn = useSelector((state) => state.getIn(['login', 'loggedIn'], false));
  const previousLoggedIn = usePrevious(loggedIn);
  const redirectUrl = urlParams.get('destination');

  useEffect(() => {
    if (loggedIn === null) {
      dispatch(userGetCurrent());
    } else if (loggedIn === true) {
      if (redirectUrl) {
        history.push(redirectUrl);
      }
    } else if (previousLoggedIn === true && loggedIn === false) {
      // clear state.
      dispatch({
        type: 'COMMERCE_ORDERS_DATA_RECEIVED',
        payload: [],
      });
      dispatch({
        type: 'COMMERCE_CART_DATA_RECEIVED',
        payload: {},
      });
      dispatch({
        type: 'COMMERCE_CART_DATA_PRODUCTS_RECEIVED',
        payload: [],
      });
      // history.push("/");
    }
  }, [dispatch, history, loggedIn, redirectUrl, previousLoggedIn]);

  return (
    <div className="WebshopLinks">
      <CartSummary setShowCartPopup={setShowCartPopup} />
    </div>
  );
};

export default WebshopLinks;
